import {call, put, takeLatest} from "redux-saga/effects";
import {authService} from "./payroll.service";
import {httpRequestsOnLoadActions} from "../http_requests_on_load";
import {
    CREATE_MANUAL_PAYROLL,
    GET_MANUAL_PAYROLL_LOADS, GET_MANUAL_PAYROLL_LOADS_SUCCESS,
    GET_PAYROLL_LOADS, GET_PAYROLL_LOADS_SUCCESS,
    GET_PAYROLL_SUMMARY,
    GET_PAYROLL_SUMMARY_SUCCESS,
    GET_PAYROLLS,
    GET_PAYROLLS_SUCCESS, VOID_PAYROLL,
} from './payroll.types';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';

/** Get Payrolls */

function* getPayrolls({type, payload}) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getPayrollService, payload.params);
        yield put({
            type: GET_PAYROLLS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* getPayrollSummary({type, payload}) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getPayrollSummaryService, payload.params);
        yield put({
            type: GET_PAYROLL_SUMMARY_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}
function* getPayrollLoads({type, payload}) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getPayrollLoadsService, payload.params);
        yield put({
            type: GET_PAYROLL_LOADS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}
function* getManualPayrollLoads({type, payload}) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    try {
        const res = yield call(authService.getManualPayrollLoadsService, payload.params);
        yield put({
            type: GET_MANUAL_PAYROLL_LOADS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}
function* createManualPayroll({type, payload}) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.createManualPayrollService, payload.params);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}
function* voidPayroll({type, payload}) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(authService.voidPayrollService, payload?.id);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

/** End */


export const watchPayroll = function* watchPayrollSaga() {
    /** Get Payrolls */
    yield takeLatest(GET_PAYROLLS, getPayrolls);
    yield takeLatest(GET_PAYROLL_SUMMARY, getPayrollSummary);
    yield takeLatest(GET_PAYROLL_LOADS, getPayrollLoads);
    yield takeLatest(GET_MANUAL_PAYROLL_LOADS, getManualPayrollLoads);
    yield takeLatest(CREATE_MANUAL_PAYROLL, createManualPayroll);
    yield takeLatest(VOID_PAYROLL, voidPayroll);
    /** End */
};
